import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from 'components/common/layout/Layout';
import SearchFilter from 'components/common/forms/SearchFilter';
import StatisticsByRound from './StatisticsByRound';
import StatisticsByStudent from './StatisticsByStudent';

const Statistics = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const [params, setParams] = useState({
    courseInfoId: Number(query.get('courseInfoId')) || undefined,
    chartRound: Number(query.get('chartRound')) || undefined,
    studentUserId: Number(query.get('studentUserId')) || undefined,
  });
  const [className, setClassName] = useState('');
  const [studentName, setStudentName] = useState('');

  useEffect(() => {
    setParams({
      ...params,
      courseInfoId: Number(query.get('courseInfoId')) || undefined,
      chartRound: Number(query.get('chartRound')) || undefined,
      studentUserId: Number(query.get('studentUserId')) || undefined,
    });
  }, [location.search]);

  return (
    <Layout>
      <h1 className="main_title mt40 mb24">통계</h1>

      <SearchFilter
        dropdown={[
          {
            id: 'course',
            placeholder: '강의명',
            width: '252px',
          },
          {
            id: 'courseInfo',
            placeholder: '분반',
            width: '240px',
          },
          {
            id: 'chartRound',
            placeholder: '(회차) 회차명',
            width: '240px',
          },
          {
            id: 'studentUserId',
            placeholder: '학생 이름 (학번)',
            width: '240px',
            useAll: true,
          },
        ]}
        setClassName={setClassName}
        setStudentName={setStudentName}
      />

      {!params.studentUserId ? (
        <StatisticsByRound
          courseInfoId={params.courseInfoId}
          chartRound={params.chartRound}
        />
      ) : (
        <StatisticsByStudent
          courseId={Number(query.get('courseId')) || undefined}
          courseInfoId={params.courseInfoId}
          chartRound={params.chartRound}
          studentUserId={params.studentUserId}
          className={className}
          studentName={studentName}
        />
      )}
    </Layout>
  );
};
export default Statistics;
